import { useMutation, gql } from '@apollo/client';
import {
  CadastrarOfertaMutation,
  CadastrarOfertaMutationVariables,
} from './__generated__/CadastrarOfertaMutation';

const CADASTRAR_OFERTA_MUTATION = gql`
  mutation CadastrarOfertaMutation(
    $id_curso: Int!
    $num_ano: Int!
    $num_oferta: Int!
    $num_semestre: Int!
    $dsc_email_assistente: String
    $dat_inicio: String
    $dat_fim: String
    $ativa: Boolean
  ) {
    cadastrarOferta(
      input: {
        id_curso: $id_curso
        num_ano: $num_ano
        num_oferta: $num_oferta
        num_semestre: $num_semestre
        dsc_email_assistente: $dsc_email_assistente
        dat_inicio: $dat_inicio
        dat_fim: $dat_fim
        ativa: $ativa
      }
    ) {
      id_oferta
      num_oferta
      num_ano
      num_semestre
      ativa
      dsc_email_assistente
      dat_inicio
      dat_fim

      turmas {
        id_turma
        id_horario
        num_turma
        dias_semana
        ativa
      }
    }
  }
`;

const useCadastrarOfertaMutation = () => {
  return useMutation<CadastrarOfertaMutation, CadastrarOfertaMutationVariables>(
    CADASTRAR_OFERTA_MUTATION
  );
};

export { useCadastrarOfertaMutation };
